import React, { useEffect, useState } from 'react';

import { Dot } from '../MenuItem/styles';
import { Content, Label, Line, Tab } from './styles';

type Props = {
  options: {
    label: string;
    value: string;
    alert?: boolean;
  }[];
  onChange: (value: string) => void;
  selected?: string;
};

const TabButton = ({
  label,
  isActive,
  onClick,
  alert,
}: {
  label: string;
  isActive: boolean;
  onClick: () => void;
  alert: boolean;
}) => (
  <Tab onClick={onClick}>
    <Label $active={isActive}>
      {label}
      {alert && <Dot />}
    </Label>
    <Line $active={isActive} />
  </Tab>
);

const SimpleTabs = ({ options, selected, onChange }: Props) => {
  const [value, setValue] = useState(selected ?? options[0].value);
  useEffect(() => {
    if (selected) setValue(selected);
  }, [selected]);

  return (
    <Content>
      {options.map((option, idx) => (
        <TabButton
          key={`${option.value}-${idx}`}
          label={option.label}
          isActive={option.value === value}
          onClick={() => {
            setValue(option.value);
            onChange(option.value);
          }}
          alert={!!option.alert}
        />
      ))}
    </Content>
  );
};

export default SimpleTabs;
